import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, OnDestroy, DoCheck } from '@angular/core';
import { DetailsViewBaseClass } from '../interfaces/detailsViewBase';

@Directive({
    selector: '[appLazyLoadContent]',
    standalone: false
})
export class LazyLoadContentDirective implements OnInit, DoCheck, OnDestroy {
  @Input('appLazyLoadContent') id: string;
  @Input('appLazyLoadContentComponent') component: DetailsViewBaseClass;
  @Input('appLazyLoadContentType') type: 'tab' | 'accordion' = 'tab';

  private hasView = false;
  private lastTabId: string;
  private lastAccordionId: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.updateView();
  }

  ngDoCheck(): void {
    const shouldUpdate =
      this.type === 'tab' && this.lastTabId !== this.component?.selectedFooterTabId ||
      this.type === 'accordion' && this.lastAccordionId !== this.component?.selectedAccordionItemId;

    if (shouldUpdate) {
      this.updateView();
    }
  }

  ngOnDestroy(): void {
    if (this.hasView) {
      this.viewContainer.clear();
    }
  }

  private updateView(): void {
    if (!this.component || !this.id) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
      return;
    }

    if (this.type === 'tab') {
      this.lastTabId = this.component.selectedFooterTabId;
    } else {
      this.lastAccordionId = this.component.selectedAccordionItemId;
    }

    let shouldShow = false;

    try {
      if (this.type === 'tab') {
        shouldShow = this.component.isTabContentVisible(this.id);
      } else {
        shouldShow = this.component.isAccordionContentVisible(this.id);
      }
    } catch (error) {
      shouldShow = true;
    }

    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
